__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "my-pace-experience-app";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(923), __webpack_require__.e(914), __webpack_require__.e(158)]).then(() => (() => (__webpack_require__(4158))))));
			register("@emotion/styled", "11.14.1", () => (Promise.all([__webpack_require__.e(914), __webpack_require__.e(985), __webpack_require__.e(479)]).then(() => (() => (__webpack_require__(1479))))));
			register("@mui/material", "6.5.0", () => (Promise.all([__webpack_require__.e(923), __webpack_require__.e(526), __webpack_require__.e(974), __webpack_require__.e(5), __webpack_require__.e(588), __webpack_require__.e(848), __webpack_require__.e(554), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(985), __webpack_require__.e(646)]).then(() => (() => (__webpack_require__(1554))))));
			register("pvs-design-icons", "1.6.2", () => (Promise.all([__webpack_require__.e(923), __webpack_require__.e(526), __webpack_require__.e(974), __webpack_require__.e(5), __webpack_require__.e(537), __webpack_require__.e(914), __webpack_require__.e(985), __webpack_require__.e(646)]).then(() => (() => (__webpack_require__(537))))));
			register("pvs-design-system", "4.11.0", () => (Promise.all([__webpack_require__.e(923), __webpack_require__.e(526), __webpack_require__.e(974), __webpack_require__.e(588), __webpack_require__.e(848), __webpack_require__.e(920), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(985), __webpack_require__.e(646), __webpack_require__.e(204), __webpack_require__.e(817), __webpack_require__.e(457)]).then(() => (() => (__webpack_require__(3158))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(961))))));
			register("react-redux", "8.1.3", () => (Promise.all([__webpack_require__.e(832), __webpack_require__.e(914), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(4832))))));
			register("react-router-dom", "7.18.4", () => (Promise.all([__webpack_require__.e(370), __webpack_require__.e(914), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(8370))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(6540))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};